<div *ngIf="addBucketsMode" class="add-buckets-section">
  <div class="dialog-header">
    <!-- <button (click)="backToBucketDetails()" class="btn back-btn"></button> -->
    <h2 mat-dialog-title>Add Buckets</h2>
    <button mat-dialog-close class="btn close-dialog-btn"></button>
  </div>

  <mat-dialog-content>

    <app-spinner *ngIf="isLoading" [isLoading]="isLoading" [errored]="errored" [minimal]="true"></app-spinner>

    <ng-container *ngIf="!isLoading">
      <input
        #searchInput
        *ngIf="buckets.length > 0"
        (keyup)="searchBucket(searchInput.value.trim())"
        placeholder="Search a Bucket"
        class="input-search"
        type="text"
      />

      <div *ngIf="buckets.length > 0 && filteredBuckets.length === 0" class="no-buckets-found-message-container">
        <div class="message-wrapper">
          <div class="no-buckets-found-image"></div>
          <p>No Buckets found</p>
        </div>
      </div>

      <div *ngIf="filteredBuckets.length > 0" class="bucket-list-container">
        <ng-scrollbar>
          <ul class="bucket-list">
            <li *ngFor="let bucket of filteredBuckets" class="bucket-item-container">
              <app-playlist-preview-item
                (selected)="onBucketSelected($event)"
                [isSelected]="bucketsToAdd.has(bucket.id)"
                [playlist]="bucket"
                [isSelectable]="true"
                [isAdded]="false"
              >
              </app-playlist-preview-item>
            </li>
          </ul>
        </ng-scrollbar>
      </div>

      <div *ngIf="filteredBuckets.length === 0 && buckets.length === 0" class="no-buckets-message text-uppercase">No Buckets available</div>
    </ng-container>

  </mat-dialog-content>

  <div mat-dialog-actions>
    <button (click)="getBucketForOverrideZoneTracksUsingBucket()" class="btn save-btn">Queue</button>
  </div>
</div>


